import { render } from "./AdminCityPaperManageView.vue?vue&type=template&id=259da552&scoped=true"
import script from "./AdminCityPaperManageView.vue?vue&type=script&lang=js"
export * from "./AdminCityPaperManageView.vue?vue&type=script&lang=js"

import "./AdminCityPaperManageView.vue?vue&type=style&index=0&id=259da552&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-259da552"]])

export default __exports__